<template>
  <div class="me">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>
    <div class="me-c">
      <div class="me-c-l">
        <div
          class="me-c-l-btn myxxbtn"
          :class="{myxxbtnactive:tabIndex == 1 ? true : false}"
          @click="btnFn(1)"
        >
          我的信息
        </div>
        <div
          class="me-c-l-btn myscbtn"
          :class="{myscbtnactive:tabIndex == 2 ? true : false}"
          @click="btnFn(2)"
        >
          我的收藏
        </div>
      </div>
      <div class="me-c-r">
        <information v-show="tabIndex == 1"></information>
        <collect v-show="tabIndex == 2"></collect>
      </div>
    </div>
  </div>
</template>

<script>
import areasData from "@/assets/areas.json";
import navigation from "@/components/common/navigation";
import information from "@/components/me/information";
import collect from "@/components/me/collect";

export default {
  name: "me",
  components: {
    navigation,
    information,
    collect,
  },
  data() {
    return {
      tabIndex: 1,
    };
  },
  methods: {
    btnFn(s) {
      this.tabIndex = s;
    },
  },
  created() {
    if (localStorage.completeStatus == 0) {
      this.$router.push("/completeinfor");
    }
  },
  mounted() {},
};
</script>

<style scoped lang="less">
a {
  text-decoration: none;
}
li {
  list-style: none;
}
input {
  outline: none;
  border: none;
  background: rgba(0, 0, 0, 0);
}
.me {
  width: 100%;
  background: #fafafa;
  overflow: hidden;
  min-height: 920px;
  .me-c {
    width: 1200px;
    min-height: 824px;
    margin: 0 auto;
    padding-top: 50px;
    .me-c-l {
      width: 250px;
      float: left;
      overflow: hidden;
      .me-c-l-btn {
        width: 200px;
        height: 50px;
        line-height: 50px;
        text-indent: 52px;
        border-left: 2px solid #ffffff;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #666666;
        background-color: #ffffff;
        cursor: pointer;
        box-sizing: border-box;
        background-position: 22px 17px;
        background-size: 18px 18px;
        background-repeat: no-repeat;
      }
      .myxxbtn {
          background-image: url('../../static/home/wdxxhui.png');
      }
      .myscbtn {
          background-image: url('../../static/home/wdschs.png');
      }
      .myxxbtnactive {
          background-image: url('../../static/home/wdxxys.png');
          color: #3476C1;
          background-color: #f5f5f5;
          border-left-color: #3476C1;
      }
      .myscbtnactive {
          background-image: url('../../static/home/wdscys.png');
          color: #3476C1;
          background-color: #f5f5f5;
          border-left-color: #3476C1;
      }
      //background:rgba(16,155,242,1);font-weight:500;color:rgba(255,255,255,1);
    }
    .me-c-r {
      width: 950px;
      float: left;
    }
  }
}
</style>